export default "__VITE_ASSET__CAnNI$2J__"